import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import { StartPaymentResource } from '@/modules/transaction/models/payment.model'
import { Data } from '@/modules/shared/models/data'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { PanelContentCampaignRoute } from '@/modules/content-campaign/routes/panel-content-campaign.route'
import { ContentCampaignResourceModel } from '@/modules/content-campaign/models/content-campaign-resource.model'
import {
  ContentCampaignPaymentLinkRequest,
  ContentCampaignSaveRequestModel
} from '@/modules/content-campaign/models/content-campaign-request.model'

@vservice()
export class PanelContentCampaignService {
  constructor(
    private readonly routes: PanelContentCampaignRoute
  ) {
  }

  create() {
    return Inertia.get(
      this.routes.create()
    )
  }

  step1(data) {
    return Inertia.post(
      this.routes.postStepOne(),
      data
    )
  }

  step2(id: number, data) {
    return Inertia.post(
      this.routes.getStepTwo(id),
      data
    )
  }

  backToStep1(id: number) {
    return Inertia.post(
      this.routes.getStepOne(id)
    )
  }

  paymentLink(id: number, data: ContentCampaignPaymentLinkRequest): Promise<Data<StartPaymentResource>> {
    return HTTP.post(
      this.routes.paymentLink(id),
      data
    )
      .then(result => result.json())
  }

  saveCampaign(data) {
    return Inertia
      .post(this.routes.saveCampaign(),
        data
      )
  }

  saveDraft(data: ContentCampaignSaveRequestModel) {
    return Inertia
      .post(
        this.routes.saveCampaignDraft(),
        data
      )
  }

  eligibleItems(data) {
    return HTTP.post(
      this.routes.getEligibleItems(),
      data
    ).then(
      result => result.json()
    )
  }

  destroy(id: number) {
    return Inertia.delete(
      this.routes.destroy(id)
    ).onBeforeAsync(() => new Promise<boolean>(
        (resolve) => {
          Dialog.create({
            component: DeleteConfirm
          }).onOk(() => resolve(true))
            .onCancel(() => resolve(false))
            .onDismiss(() => resolve(false))
        }
      )
    )
  }

  updateCampaignDetail(id: ContentCampaignResourceModel['id'], data: Partial<ContentCampaignResourceModel>) {
    return Inertia.put(
      this.routes.updateCampaignDetail(id),
      data,
      {
        preserveState: false,
        preserveScroll: true
      }
    )
  }

  destroyItem(campaignId, itemId) {
    return Inertia.delete(
      this.routes.destroyItem(campaignId, itemId)
    ).onBeforeAsync(() => new Promise<boolean>(
        (resolve) => {
          Dialog.create({
            component: DeleteConfirm
          }).onOk(() => resolve(true))
            .onCancel(() => resolve(false))
            .onDismiss(() => resolve(false))
        }
      )
    )
  }

}
